<template>
  <div :class="['activity-card__idle', type, { 'activity-card__idle--compact': compact }]">
    <div class="icon">
      <component :is="icon" />
    </div>
    <div class="labels">
      <h1>{{ title }}</h1>
      <span v-show="datetime"> {{ datetime }}</span>
    </div>
  </div>
</template>

<script>
import SetupIcon from "@/assets/images/icons/setup-card-icon.svg";
import PauseIcon from "@/assets/images/icons/pause-card-icon.svg";
import PlayIcon from "@/assets/images/icons/play-card-icon.svg";
import FinishIcon from "@/assets/images/icons/finish-card-icon.svg";

const icons = {
  setup: SetupIcon,
  stop: PauseIcon,
  start: PlayIcon,
  finish: FinishIcon,
};
export default {
  components: {
    SetupIcon,
    PauseIcon,
    PlayIcon,
    FinishIcon,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    datetime: {
      type: String,
      default: null,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    icon() {
      return icons[this.type];
    },
  },
};
</script>

<style lang="scss">
$setup: #78909c;
$stop: #ef5350;
$start: #ffa726;
$finish: #66bb6a;

$hover: #974900;

.activity-card__idle {
  box-shadow: 0px 4px 24px rgba(58, 46, 38, 0.1);

  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  border-radius: 24px;

  padding: 24px 20px;

  border: 1px solid #cfc4be;

  h1,
  span {
    font-family: "Raleway";
    font-style: normal;
    font-weight: 600;
  }

  h1 {
    font-size: 28px;
    line-height: 38px;
    color: #4c4541;
    margin-bottom: 0;
    text-align: center;
  }

  span {
    font-size: 18px;
    line-height: 26px;
    color: #998f8a;
  }

  .labels {
    display: flex;
    flex-direction: column;
    gap: 8.5px;
  }

  .icon {
    border-radius: 6px;
    padding: 16px;
    width: 112px;
    height: 112px;
  }

  &.setup>.icon {
    background-color: $setup;
    border: 1px solid $setup;
  }

  &.stop>.icon {
    background-color: $stop;
    border: 1px solid $stop;
  }

  &.start>.icon {
    background-color: $start;
    border: 1px solid $start;
  }

  &.finish>.icon {
    background-color: $finish;
    border: 1px solid $finish;
  }

  &:hover {
    background: #ffede2;

    h1,
    span {
      color: $hover;
    }

    .icon {
      background: #fff;
      border: 1px solid $hover;
    }

    path {
      fill: $hover;
    }
  }

  &:active {
    background: #ffdbc4;
  }
}

.activity-card__idle.activity-card__idle--compact {
  padding: 24px 18px 26px;
  gap: 14px;
  justify-content: center;

  .icon {
    flex-shrink: 0;
    width: 56px;
    height: 56px;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    svg {
      width: 30px;
      height: 30px;
      display: block;
      flex-shrink: 0;
    }
  }

  .labels {
    gap: 12px;
    flex-shrink: 0;
    width: 100%;
    align-items: center;
  }

  h1 {
    font-size: 20px;
    line-height: 28px;
  }

  span {
    font-size: 14px;
    line-height: 22px;
    font-weight: 400;
  }
}

@media (min-width: 481px) and (max-width: 1024px) {
  .activity-card__idle:not(.activity-card__idle--compact) {
    gap: 8px;
    padding: 12px 16px;
    border-radius: 18px;

    .icon {
      width: 88px;
      height: 88px;
      padding: 12px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;

      svg {
        display: block;
        width: 100%;
        height: 100%;
        flex-shrink: 0;
      }
    }

    .labels {
      gap: 2px;

      h1 {
        font-size: 22px;
        line-height: 28px;
      }

      span {
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
}

@media (max-width: 480px) {
  .activity-card__idle:not(.activity-card__idle--compact) {
    .icon {
      padding: 0;
      width: 45px;
      height: 45px;

      svg,
      path {
        transform: scale(0.5);
        margin-left: -8.8px;
        margin-top: -7px;
      }
    }

    .labels {
      gap: 4px;

      h1 {
        font-size: 18px;
        line-height: 26px;
      }

      span {
        font-size: 14px;
        line-height: 20px;
      }
    }
  }

  .activity-card__idle.activity-card__idle--compact {
    padding: 20px 14px 22px;
    gap: 12px;

    .icon {
      width: 52px;
      height: 52px;
      padding: 9px;

      svg {
        width: 28px;
        height: 28px;
      }

      svg,
      path {
        transform: none;
        margin: 0;
      }
    }

    .labels {
      gap: 10px;

      h1 {
        font-size: 17px;
        line-height: 24px;
      }

      span {
        font-size: 12px;
        line-height: 18px;
      }
    }
  }
}
</style>
